<template>
	<div class="top-session-button__container">
		<button
			v-if="authenticated && hasKyc && canViewTransactions"
			class="top-session-button button button__primary"
			@click="openDeposit"
		>
			Deposit
		</button>

		<router-link
			v-if="!authenticated"
			class="top-session-button button button__secondary outline link"
			style="margin-right: 2px"
			:to="{
				name: 'login',
				query: {
					next: $route.query.next ? $route.query.next : $route.fullPath,
				},
			}"
			>Login</router-link
		>
		<router-link
			v-if="!authenticated"
			class="top-session-button button button__secondary link"
			:to="{
				name: 'register',
				query: {
					next: $route.query.next ? $route.query.next : $route.fullPath,
				},
			}"
			>Register</router-link
		>
		<bottom-sheet
			:ref="'bottomSheet'"
			v-if="canShowBottomSheet"
			@close="closeBottomSheet"
			@has-mounted="showBottomSheet"
		>
			<div style="padding: 20px">
				<deposit :user="user" @close="closeBottomSheet" />
			</div>
		</bottom-sheet>
	</div>
</template>

<script>
import Deposit from "../Session/Account/Deposit.vue";

export default {
	components: { Deposit },
	data() {
		return {
			canShowBottomSheet: false,
		};
	},
	methods: {
		openDeposit() {
			this.canShowBottomSheet = true;
			setTimeout(() => {
				const el = document.querySelector(
					"#app > div:nth-child(8) > div > div.card > div.contents > div > div > div > div.input__container.deposit.input.account__section__input > input"
				);
				utils.focusAndOpenKeyboard(el, 0);
			}, 300);
		},
		showBottomSheet() {
			this.canShowBottomSheet = true;
			this.$nextTick(() => {
				this.$refs.bottomSheet.setState("open");
			});
		},
		closeBottomSheet() {
			this.$refs.bottomSheet.setState("close");
			this.$nextTick(() => {
				this.canShowBottomSheet = false;
			});
		},
	},
	computed: {
		authenticated() {
			return this.$store.getters.authenticated;
		},
		canViewTransactions() {
			let vm = this;
			if (this.env.kyc.required) {
				if (
					vm.kycData.status &&
					vm.kycData.status !== undefined &&
					vm.kycData.status == "3"
				) {
					return false;
				} else {
					return true;
				}
			} else {
				return true;
			}
		},
		kycData() {
			return this.$store.getters.user.kyc;
		},
		hasKyc() {
			if (this.env.kyc.required === true) {
				return this.$store.getters.user.has_kyc;
			} else {
				return true;
			}
		},
		user() {
			let user = this.$store.getters.user;
			user.bonus = this.bonus;
			user.points = this.points;

			return user;
		},
	},
};
</script>

<style lang="scss" scoped>
.top-session-button {
	padding: 8px 15px;
	font-size: var(--font-small);
	border-radius: 8px;
	font-weight: var(--font-weight-medium);
	&__container {
		.button__primary {
			border: 0px;
		}
		.button__secondary {
			border: 0px;
			&.outline {
				font-weight: var(--font-weight-bold);
			}
		}
		margin-right: 10px;
	}
}
</style>
